import type { TCargoType } from 'api/swagger';
import { ALL_CARGO_TYPES } from './constants';
import type { TCargoTypeOption } from './types';

export const normalizeCargoTypes = (values: TCargoTypeOption[]): TCargoType[] =>
  values[values.length - 1] === ALL_CARGO_TYPES
    ? []
    : values.filter((value): value is TCargoType => value !== ALL_CARGO_TYPES);
